/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForeignExperience } from '../../models/foreign-experience';

export interface GetForeignExperiences$Params {
  profileId: string;
}

export function getForeignExperiences(http: HttpClient, rootUrl: string, params: GetForeignExperiences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ForeignExperience>>> {
  const rb = new RequestBuilder(rootUrl, getForeignExperiences.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ForeignExperience>>;
    })
  );
}

getForeignExperiences.PATH = '/studentprofile/{profileId}/foreignexperience';
